import dayjs from '../../Libraries/dayjs'

const initial = {
  search: '',
  selected: [],
  companies: [],
  loading: true,
  modal: {
    texte: '',
    open: false,
    action: undefined
  }
}

function companies(state = initial, action) {
  switch (action.type) {
    case 'SEARCH_COMPANIE':
      return {
        ...state,
        search: action.value
      }
    case 'LOADING_COMPANIES':
      return {
        ...state,
        loading: false
      }
    case 'SELECTED_COMPANIES':
      return {
        ...state,
        selected: action.value
      }
    case 'GET_COMPANIES':
      return {
        ...state,
        selected: [],
        companies: action.value
      }
    case 'MODAL_COMPANIES':
      return {
        ...state,
        modal: {
          open: action.open,
          texte: action.texte,
          action: action.action
        }
      }
    case 'BLOCK_COMPANIE':
      return {
        ...state,
        companies: state.companies.map(item => {
          return (action.companies.includes(item.id))
            ? {
                ...item,
                die: (action.value) ? dayjs().unix() : 0
              }
            : item
        })
      }
    case 'ENVIRONMENT_COMPANIE':
      return {
        ...state,
        companies: state.companies.map(item => {
          return (action.companies.includes(item.id))
            ? {
                ...item,
                beta: action.value
              }
            : item
        })
      }
    default:
      return state
  }
}

export default companies
